module.exports = __webpack_public_path__ + "img/weight.e66ca232.png";